import { useOffline } from '../hooks/useOffline';
import { Wifi, WifiOff, RefreshCw } from 'lucide-react';

function OfflineIndicator() {
  const { isOnline, isSyncing, pendingCount } = useOffline();

  if (isOnline && !isSyncing && pendingCount === 0) {
    // Everything is normal, don't show indicator
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50">
      {!isOnline && (
        <div className="bg-destructive text-destructive-foreground px-4 py-2 rounded-lg shadow-lg flex items-center gap-2 animate-pulse">
          <WifiOff className="h-4 w-4" />
          <span className="text-sm font-medium">Offline Mode</span>
          {pendingCount > 0 && (
            <span className="ml-2 bg-destructive-foreground/20 px-2 py-0.5 rounded text-xs">
              {pendingCount} {pendingCount === 1 ? 'order' : 'orders'} pending
            </span>
          )}
        </div>
      )}

      {isOnline && isSyncing && (
        <div className="bg-blue-500 text-white px-4 py-2 rounded-lg shadow-lg flex items-center gap-2">
          <RefreshCw className="h-4 w-4 animate-spin" />
          <span className="text-sm font-medium">Syncing orders...</span>
          {pendingCount > 0 && (
            <span className="ml-2 bg-white/20 px-2 py-0.5 rounded text-xs">
              {pendingCount} remaining
            </span>
          )}
        </div>
      )}

      {isOnline && !isSyncing && pendingCount > 0 && (
        <div className="bg-orange-500 text-white px-4 py-2 rounded-lg shadow-lg flex items-center gap-2">
          <Wifi className="h-4 w-4" />
          <span className="text-sm font-medium">Online</span>
          <span className="ml-2 bg-white/20 px-2 py-0.5 rounded text-xs">
            {pendingCount} {pendingCount === 1 ? 'order' : 'orders'} queued
          </span>
        </div>
      )}
    </div>
  );
}

export default OfflineIndicator;
